import { IToken } from "interfaces/IToken";
import { atom } from "recoil";

export const tokenState = atom<IToken>({
  key: "token",
  default: {
    jwtToken: localStorage.getItem("token") || null,
    userId: localStorage.getItem("userId")
      ? parseInt(localStorage.getItem("userId")!)
      : null,
  },
});
